import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

import brandConfig from '../../../config/brand';
import { GoogleSignInButton } from '../components/GoogleSignInButton';


export const TeamLogin = () => {
  const navigate = useNavigate();
  const goToMagicLogin = () => {
    navigate('/');
  };

  return (
    <Background>
      <StyledImg src={brandConfig.logo} alt={`${brandConfig.displayName} logo`} />
      <Container>
        <Title>Admin Login</Title>
        <Subtitle>
          Sign in with your <strong>@farmstream.co.uk</strong> Google Workspace account.
        </Subtitle>
        <GoogleSignInButton />
        <ToolsButton type="button" onClick={() => navigate('/team/migrations')}>
          Camera migrations
        </ToolsButton>
        <ToolsButton type="button" onClick={() => navigate('/team/access')}>Staff access &amp; sessions</ToolsButton>
        <ToolsButton type="button" onClick={() => navigate('/tools')}>
          Team tools (share QR decoder)
        </ToolsButton>
        <LinkButton type="button" onClick={goToMagicLogin}>
          Back to Magic Link Login
        </LinkButton>
      </Container>
    </Background>
  );
};

const Background = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100dvh;
  background-color: #f5f5f5;
  padding: 1rem;
`;

const StyledImg = styled.img`
  max-width: 15rem;
  margin-bottom: 2rem;
  background-color: white;
  padding: 1rem;
  border-radius: 0.5rem;

  @media (max-width: 500px) {
    max-width: 9rem;
  }
`;

const Container = styled.div`
  background-color: white;
  padding: 2rem;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: 400px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;

  @media (max-width: 500px) {
    padding: 1rem;
    max-width: unset;
  }
`;

const Title = styled.h2`
  text-align: center;
  margin: 0;
`;

const Subtitle = styled.p`
  text-align: center;
  color: #6b7280;
  font-size: 0.85rem;
  margin: 0 0 0.5rem;
  strong {
    color: #29a8d3;
  }
`;

const ToolsButton = styled.button`
  width: 100%;
  padding: 0.6rem 0.75rem;
  background: transparent;
  border: 1px solid #29a8d3;
  color: #29a8d3;
  border-radius: 6px;
  font-size: 0.9rem;
  cursor: pointer;
  &:hover {
    background: #e6f7ff;
  }
`;

const LinkButton = styled.button`
  background: none;
  border: none;
  color: #0066cc;
  cursor: pointer;
  text-decoration: underline;
  margin-top: 0.5rem;
  font-size: 0.85rem;
  &:hover {
    color: #004499;
  }
`;
